import type { WorksheetAssignScheduleStatus } from '@mathflat/domain/Worksheet'
import { tJosa } from '@mathflat/shared/i18n/tJosa'

// 브랜드 용어(출제)가 들어가는 문구는 함수로 두어 렌더 시점에 푼다. 모듈 로드 시점에는 언어팩이 준비되지 않았을 수 있다
export const SCHEDULE_STRINGS = {
  toggleLabel: () => `예약${tJosa('출제')}`,
  tooltip: () =>
    `예약한 시간에 학습지가 자동으로 ${tJosa('출제')}됩니다.\n예약 가능 시간 : 지금으로부터 최소 30분 뒤 ~ 최대 7일 이내\n예약 취소 : ${tJosa('출제')} 예정 시간 5분 전까지 가능`,
  openList: '예약 목록 보기',
  submitNow: () => `바로 ${tJosa('출제')}하기`,
  submitSchedule: () => `예약 ${tJosa('출제')}하기`,
  limitStudents: '선택된 학생이 100명이 넘으면 예약이 불가능합니다.',
  limitWaiting: '예약은 최대 400개까지 가능합니다.',
  deadlinePassed: '예약 가능한 시간이 지났습니다. 시간을 다시 선택해 주세요.',
  /** 예약 있음 모드 */
  reservedSuffix: '예약됨',
  editTime: '예약 시간 변경',
  submitReserved: () => `${tJosa('출제')} 예약됨`,
  submitChange: '예약 변경하기',
  pendingStudentLabel: () => `${tJosa('출제')} 예약됨`,
  removeStudentConfirm: () =>
    `${tJosa('출제')} 예약이 이미 되어있는 학생입니다.\n해당 학생만 예약 ${tJosa('출제')}에서 제외하시겠습니까?`,
  removedStudent: () => `해당 학생이 예약 ${tJosa('출제')}에서 제외되었습니다.`,
  changed: () => `${tJosa('출제')} 예약이 변경되었습니다.`,
  toggleOffConfirm: () =>
    `예약 ${tJosa('출제')}를 OFF 상태로 변경하면\n예약된 ${tJosa('출제', '이/가')} 취소되며 바로 ${tJosa('출제')} 할 수 있도록 변경됩니다.\n진행하시겠습니까?`,
  deadlineLocked: () => `${tJosa('출제')} 5분 전에는 수정이 불가능합니다.`,
  assignNowWarning: () =>
    `기존에 예약되어 있는 학생은 예약이 취소됩니다.\n그래도 즉시 ${tJosa('출제')}하시겠습니까?`,
  deleteNotice: () =>
    `${tJosa('출제')} 예약이 걸린 학습지는 예약된 ${tJosa('출제')}도 함께 취소됩니다.`,
  editGuard: () =>
    `${tJosa('출제')} 예약이 되어있는 학습지입니다.\n학습지를 수정할 경우 예약된 ${tJosa('출제', '이/가')} 취소됩니다.\n그래도 수정하시겠습니까?`,
}

export const SCHEDULE_STATUSES: WorksheetAssignScheduleStatus[] = ['WAITING', 'FAILED', 'DONE']

export const SCHEDULE_LIST_STRINGS = {
  title: () => `${tJosa('출제')} 예약 목록`,
  subtitle: '현재 예약된 모든 내역을 확인할 수 있어요.',
  back: '돌아가기',
  cancel: '예약 취소',
  cancelConfirm: () =>
    `선택된 학생들에게 학습지 ${tJosa('출제', '이/가')} 되지 않습니다.\n예약을 취소하시겠습니까?`,
  empty: '목록이 없습니다.',
  loadFailed: '목록을 불러오지 못했어요.',
  retry: '다시 시도',
  deletedWorksheet: '(삭제된 학습지)',
  deletedStudent: '(삭제된 학생)',
  failurePartial: () => `실패(일부학생 ${tJosa('출제')} 실패)`,
  failureAll: () => `실패(오류로 인한 전체 학생 ${tJosa('출제')} 실패)`,
  tab(status: WorksheetAssignScheduleStatus) {
    return { WAITING: '대기 중', FAILED: `${tJosa('출제')} 실패`, DONE: `${tJosa('출제')} 완료` }[
      status
    ]
  },
  /** 카드 라벨·건수 문구에 쓰는 짧은 상태명 */
  short(status: WorksheetAssignScheduleStatus) {
    return { WAITING: '대기', FAILED: '실패', DONE: '완료' }[status]
  },
}

export const MAX_STUDENTS_PER_SCHEDULE = 100
export const MAX_WAITING_SCHEDULES = 400
